import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { normalizeImgSrc } from '../utils';

const extractBlocks = suggestionFields => {
  const blocks = suggestionFields?.blocks || [];
  const blockHeadingText = blocks.filter(i => i.block_type === 'heading' || i.block_type === 'body_text') || [];
  const headingHtml = blockHeadingText
    .map(i => {
      return i.block_type === 'heading'
        ? `<h2 style="text-align: center;">${i.text}</h2>`
        : `<p style="text-align: center;">${i.text}</p>`;
    })
    .join('');

  const blockMedia = blocks.find(b => b.block_type === 'media') ?? null;
  const buttonCta = blocks.find(b => b.block_type === 'cta') ?? null;
  return { blockMedia, headingHtml, buttonCta };
};

export const buildImageWithTextCol1Section = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));

  if (!newSection?.html) return null;

  const { blockMedia, headingHtml, buttonCta } = extractBlocks(suggestionFields);

  const fieldUpdate = {
    cardTitle: {
      show: !!headingHtml,
      content: headingHtml,
    },
    cardImage: {
      show: !!blockMedia,
      src: normalizeImgSrc(blockMedia?.media.url || ''),
    },
    button: {
      show: !!buttonCta,
      text: buttonCta?.label || '',
      link: '#',
    },
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionImageWithTextCol1(newSection.html, fieldUpdate),
  };
};
